export default "__VITE_ASSET__C_0vz0Ri__"